document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".product-gallery__carousel");

  carousels.forEach(carousel => {
    const prevBtn = carousel.parentElement.querySelector("[data-slider-prev]");
    const nextBtn = carousel.parentElement.querySelector("[data-slider-next]");

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        carousel.scrollBy({ left: -carousel.clientWidth, behavior: "smooth" });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        carousel.scrollBy({ left: carousel.clientWidth, behavior: "smooth" });
      });
    }
  });
});



document.addEventListener("DOMContentLoaded", function() {
        function attachConsent(checkboxId, buttonWrapperSelector) {
          const checkbox = document.getElementById(checkboxId);
          const submitBtn = document.querySelector(buttonWrapperSelector + " button");

          if (checkbox && submitBtn) {
            submitBtn.setAttribute("disabled", "true");

            checkbox.addEventListener("change", function() {
              if (this.checked) {
                submitBtn.removeAttribute("disabled");
              } else {
                submitBtn.setAttribute("disabled", "true");
              }
            });
          }
        }

        // Homepage newsletter
        attachConsent("homepage-accepts-marketing", "#homepage-newsletter-submit-wrapper");

        // If you already added Footer + Password page:
        attachConsent("footer-accepts-marketing", "#footer-newsletter-submit-wrapper");
        attachConsent("accepts-marketing", "#newsletter-submit-wrapper");
      });


     /**
 * This script will:
 * - Find all newsletter forms (footer, template-based, popup, and password page)
 * - Inject a "marketing-consent" checkbox block if missing
 * - Disable the submit button until the checkbox is checked
 */

document.addEventListener("DOMContentLoaded", function () {
  // --- 1. Footer form ---
  const footerForm = document.querySelector("form[id^='newsletter-form-sections'][id*='__footer']");
  if (footerForm) {
    const submitBtn = footerForm.querySelector("button[type='submit']");
    if (submitBtn && !footerForm.querySelector(".marketing-consent")) {
      const checkboxId = "footer-accepts-marketing";
      const marketingDiv = document.createElement("div");
      marketingDiv.className = "marketing-consent text-left";
      marketingDiv.innerHTML = `
        <label>
          <input type="checkbox" id="${checkboxId}" name="contact[accepts_marketing]" value="true">
          I would like to receive marketing emails about products, services, and special offers.
        </label>
      `;
      submitBtn.parentNode.insertAdjacentElement("beforebegin", marketingDiv);
      submitBtn.setAttribute("disabled", "true");

      const checkbox = document.getElementById(checkboxId);
      checkbox.addEventListener("change", function () {
        submitBtn.toggleAttribute("disabled", !this.checked);
      });
    }
  }

  // --- 2. Template newsletter forms ---
  const templateForms = document.querySelectorAll("form[id^='newsletter-form-template']");
  templateForms.forEach((form, index) => {
    const submitBtn = form.querySelector("button[type='submit']");
    if (submitBtn && !form.querySelector(".marketing-consent")) {
      const checkboxId = `template-accepts-marketing-${index}`;
      const marketingDiv = document.createElement("div");
      marketingDiv.className = "marketing-consent text-left";
      marketingDiv.innerHTML = `
        <label>
          <input type="checkbox" id="${checkboxId}" name="contact[accepts_marketing]" value="true">
          I would like to receive marketing emails about products, services, and special offers.
        </label>
      `;
      submitBtn.insertAdjacentElement("beforebegin", marketingDiv);
      submitBtn.setAttribute("disabled", "true");

      const checkbox = marketingDiv.querySelector("input");
      checkbox.addEventListener("change", function () {
        submitBtn.toggleAttribute("disabled", !this.checked);
      });
    }
  });

  // --- 3. Popup newsletter forms ---
  const popupForms = document.querySelectorAll("newsletter-popup form.form");
  popupForms.forEach((form, index) => {
    const submitBtn = form.querySelector("button[type='submit'], .button, [type='submit']");
    if (submitBtn && !form.querySelector(".marketing-consent")) {
      const checkboxId = `popup-accepts-marketing-${index}`;
      const marketingDiv = document.createElement("div");
      marketingDiv.className = "marketing-consent text-left";
      marketingDiv.style.marginTop = "10px";
      marketingDiv.innerHTML = `
        <label>
          <input type="checkbox" id="${checkboxId}" name="contact[accepts_marketing]" value="true">
          I would like to receive marketing emails about products, services, and special offers.
        </label>
      `;
      submitBtn.insertAdjacentElement("beforebegin", marketingDiv);
      submitBtn.setAttribute("disabled", "true");

      const checkbox = marketingDiv.querySelector("input");
      checkbox.addEventListener("change", function () {
        submitBtn.toggleAttribute("disabled", !this.checked);
      });
    }
  });

  // --- 4. Password page form ---
  const passwordForm = document.querySelector("#contact_form");
  if (passwordForm) {
    const submitBtn = passwordForm.querySelector("button[type='submit']");
    if (submitBtn && !passwordForm.querySelector(".marketing-consent")) {
      const checkboxId = "password-accepts-marketing";
      const marketingDiv = document.createElement("div");
      marketingDiv.className = "marketing-consent text-left";
      marketingDiv.style.marginTop = "10px";
      marketingDiv.innerHTML = `
        <label>
          <input type="checkbox" id="${checkboxId}" name="contact[accepts_marketing]" value="true">
          I would like to receive marketing emails about products, services, and special offers.
        </label>
      `;
      submitBtn.insertAdjacentElement("beforebegin", marketingDiv);
      submitBtn.setAttribute("disabled", "true");

      const checkbox = marketingDiv.querySelector("input");
      checkbox.addEventListener("change", function () {
        submitBtn.toggleAttribute("disabled", !this.checked);
      });
    }
  }
});

// remove consent from international forms
document.addEventListener("DOMContentLoaded", function () {
  // Check if we are on the Returns Form page
  if (window.location.pathname.includes("/pages/returns-form")) {
    const consentBlock = document.querySelector(".marketing-consent");
    if (consentBlock) {
      consentBlock.remove(); //  Remove marketing consent div completely
    }

    // Also enable the submit button since it was disabled by the consent logic
    const submitBtn = document.querySelector("#contact_form button[type='submit']");
    if (submitBtn) {
      submitBtn.removeAttribute("disabled");
    }
  }
});

// Gift Card Img size increase
document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector(".gift-card__image");
  if (!img) return;

  // Get the current base URL (without ?width=...)
  let baseUrl = img.src.split("?")[0];

  // Force Shopify CDN to serve very high-resolution versions
  const highResWidths = [900, 1200, 1600, 2000, 2500];
  const srcset = highResWidths
    .map(w => `${baseUrl}?v=1759746331&width=${w} ${w}w`)
    .join(", ");

  // Replace the image attributes with crisp large variants
  img.src = `${baseUrl}?v=1759746331&width=2000`;
  img.srcset = srcset;
  img.sizes = "(max-width: 1200px) 100vw, 1400px";

  // Increase visible display size
  img.style.maxWidth = "100%";   // was 700px
  img.style.width = "100%";
  img.style.height = "auto";
  img.style.objectFit = "contain";
  img.style.display = "block";
  img.style.margin = "0 auto";    // center the image
});


document.addEventListener('DOMContentLoaded', () => {
  // Wait until the custom element is defined
  customElements.whenDefined('predictive-search').then(() => {
    const proto = window.customElements.get('predictive-search').prototype;

    // Replace / override the doPredictiveSearch_fn function
    proto.doPredictiveSearch_fn = async function() {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      const baseUrl = `${window.Shopify.routes.root}search${this.supportsPredictiveApi() ? "/suggest" : ""}`;

      const queryParams = new URLSearchParams({
        q: this._queryInput ? this._queryInput.value : '',
        section_id: "predictive-search",
        "resources[limit]": "10",
        "resources[limit_scope]": "each",
        "resources[type]": "product,collection,article,page",
        "resources[options][fields]": "title,variants.title,product_type,vendor,tag"
      });

      try {
        const response = await cachedFetch(`${baseUrl}?${queryParams.toString()}`, {
          signal: this._fetchAbortController ? this._fetchAbortController.signal : undefined
        });

        const html = await response.text();
        const tempDoc = new DOMParser().parseFromString(html, "text/html");
        const section = tempDoc.querySelector(".shopify-section");

        if (section) {
          this.querySelector('[slot="results"]').replaceChildren(...section.children);
        } else {
          this.querySelector('[slot="results"]').innerHTML = "";
        }
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("Predictive search override error:", e);
        }
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    };
  });
});





